<script>
	import AuthScreenBrand from "src/components/AuthScreenBrand/AuthScreenBrand.svelte";
	import { navigate } from "svelte-routing";
	import { Button, Label } from "@sveltestrap/sveltestrap";
	import CustomInput from "../components/CustomInput/CustomInput.svelte";
	import ErrorMessageHandler from "../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import SuccessMessageHandler from "../components/ErrorMessageHandler/SuccessMessageHandler.svelte";
	import Loader from "../components/Loader/Loader.svelte";
	import { doReset } from "../store/auth/auth";
	import { errorMessage, loading, successMessage } from "../store/store";
	let password = "";
	let confirmPassword = "";
	let err;
	let success;

	let okeToken = window.location.pathname.split("/reset-password/")[1];
	let token = okeToken?.replaceAll(" ", "");
	if (!token) {
		window.location.replace(window.location.origin + "/login");
	}
	let removeTraillingSlash = token.endsWith("/") ? token.slice(0, -1) : token;
	let testToken = removeTraillingSlash.toString();

	let img = "/assets/getgo-logo-green.png";

	errorMessage.subscribe((value) => {
		err = value;
	});

	successMessage.subscribe((value) => {
		success = value;
	});

	async function submit() {
		if (password !== confirmPassword) {
			errorMessage.set("Password and Confirm Password must match");
		} else {
			let res = doReset({ password, testToken });
		}
	}
	let load;
	loading.subscribe((value) => {
		load = value;
	});

	const handleNavigate = () => {
		errorMessage.set("");
		successMessage.set("");
		navigate("/login");
	};
</script>

<main>
	<div class="main-container">
		<AuthScreenBrand />
		<div class="right">
			<div class="sign-in">
				<h2>Reset your password</h2>
				<ErrorMessageHandler message={err} />
				<SuccessMessageHandler message={success} />
				<div class="mt-3 mb-1">
					<Label for="password">
						<b>New Password</b>
					</Label>
				</div>
				<div>
					<CustomInput
						props={{ id: "password" }}
						type="password"
						bind:value={password}
					/>
				</div>
				<div class="mt-3 mb-1">
					<Label for="confirmPassword">
						<b>Confirm Password</b>
					</Label>
					<div />
					<div>
						<CustomInput
							props={{ id: "confirmPassword" }}
							type="password"
							bind:value={confirmPassword}
						/>
					</div>
					<div class="forgot my-4">
						<p>Do you want to login?</p>
						<p
							class="link-text link mx-1"
							on:click={handleNavigate}
							on:keydown={() => {}}
						>
							Click here
						</p>
					</div>
					<div class="my-2">
						<Button
							block
							disabled={success}
							class="themeButton primary"
							on:click={submit}
						>
							{#if load}
								<Loader />
							{:else}
								Reset Password
							{/if}
						</Button>
					</div>
				</div>
			</div>
		</div>
	</div>
</main>
